import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APP_ROUTES } from '../../app.routes.model';
import { StorageService } from '../services/storage/storage.service';
import { UserFeatureFlags } from '@api/model/my-api';

export const hasFeatureEnabledGuard: CanActivateFn = (route) => {
  const access =
    inject(StorageService).getUserFeatures()?.[
      route.data['feature'] as keyof UserFeatureFlags
    ];

  if (access) {
    return true;
  }

  // TODO this should point to some better route which is accessible to all e.g. dashboard
  return inject(Router).navigate([APP_ROUTES.notAllowed]);
};
